import type { FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import PersonalizationAroundTheGlobeImage from './PersonalizationAroundTheGlobeImage'

const copy = {
  heading: `Personalization around the globe`,
  content: [
    `Welcome to the third annual State of Personalization Report, a global look at the latest trends in personalization, first-party data, privacy, and consumer loyalty.`,

    `In this report, we surveyed nearly 3,500 businesses and consumers across five continents to get a pulse check of how attitudes and experiences with personalization have changed over the past 12 months.`,

    `Read on to explore our key findings, or download the full report to get the complete picture of the trends shaping the future of personalization.`,
  ],
}

const PersonalizationAroundTheGlobe: FC = () => {
  const theme = useTheme()

  return (
    <StyledSectionBase variant="2Col">
      <Section.Copy>
        <Typography variant="h2" tag="h2">
          {copy.heading}
        </Typography>
        {copy.content.map((el) => (
          <Typography
            variant="pLarge"
            key={el}
            tokens={{
              color: theme.palette.twilio.gray[80],
            }}
          >
            {el}
          </Typography>
        ))}
      </Section.Copy>
      <Section.Contents>
        <PersonalizationAroundTheGlobeImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

export default PersonalizationAroundTheGlobe

const StyledSectionBase = styled(SectionBase)`
  ${Section.Contents} {
    justify-content: left;
  }
`
